import React from "react"
import { CollectionProduct } from "../types/ShopifyCollection"
import { Button } from "./layout/Button"
import { ProductCard } from "./ProductCard"
import { ShopLook } from "./ShopLook"

export const CollectionsPreview = ({ products, looks }) => {
  return (
    <>
      <div className="grid w-full grid-cols-2 gap-8 md:grid-cols-3">
        {products.map((product, i) => (
          <ProductCard
            key={product.handle}
            product={{
              availableForSale: product.availableForSale,
              descriptionHtml: product.descriptionHtml,
              title: product.title,
              images: product.images.map(
                item => item
              ) as CollectionProduct["images"],
              priceRange: product.priceRange,
              handle: product.handle,
            }}
          />
        ))}
      </div>

      <Button href={"/objects"}>SHOP ALL OBJECTS</Button>

      <div className="hidden w-full grid-cols-1 gap-8 md:grid justify-items-center sm:justify-items-start sm:grid-cols-2 md:grid-cols-3">
        {looks.map((look, i) => (
          <ShopLook
            key={look.node.handle}
            to={`/looks?handle=${look.node.handle}`}
            img={{
              src: look.node.image.src,
              alt: `Look ${i}`,
            }}
          />
        ))}
      </div>
      <div className="grid w-full grid-cols-1 gap-8 justify-items-center sm:justify-items-start md:hidden">
        <ShopLook
          key={looks[0].node.handle}
          to={`/looks?handle=${looks[0].node.handle}`}
          img={{
            src: looks[0].node.image.src,
            alt: `Look ${0}`,
          }}
        />
      </div>

      <Button href={"/shop-the-feed"}>SHOP THE FEED</Button>
    </>
  )
}
